import * as React from 'react';

import { myTheme } from '../../../../../assets/styles/my-theme';

import { DefaultButton, Dialog, DialogFooter, DialogType, DocumentCardActions, getFocusStyle, getTheme, IButtonProps, Icon, ITheme, PrimaryButton } from '@fluentui/react';
import { mergeStyleSets } from '@fluentui/merge-styles';

import abilityBuild from '../../../../../shared/CASL/appAbility';
import { subject } from "@casl/ability";

import { IFile, IProtocol } from '../../../../../shared/interfaces';
import CircleLoader from '../../../../Loader/CircleLoader/CircleLoader';
import { DocumentCard, DocumentCardDetails, DocumentCardPreview, DocumentCardTitle, DocumentCardType, IDocumentCardPreviewProps, IDocumentCardStyles, List, Text } from '@fluentui/react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useBoolean } from '@fluentui/react-hooks';
import { getFileTypeIconProps } from '@fluentui/react-file-type-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AppUtilities from '../../../../../shared/Utilities/appUtilities';
import { Protocol_State } from '../../../../../shared/enums';

const theme: ITheme = getTheme();
const { semanticColors, fonts } = theme;
const { palette } = myTheme;
const documentCardSyles: Partial<IDocumentCardStyles> = {
    root: {
        height: 65
    }
}
const classNames = mergeStyleSets({
    itemCell: [
        getFocusStyle(theme, { inset: -1 }),
        {
            minHeight: 54,
            padding: 10,
            boxSizing: 'border-box',
            borderBottom: `1px solid ${semanticColors.bodyDivider}`,
            display: 'flex',
            selectors: {
                '&:hover': { background: palette.neutralLight },
            },
        },
    ],
    itemImage: {
        flexShrink: 0,
    },
    itemContent: {
        marginLeft: 10,
        overflow: 'hidden',
        flexGrow: 1,
    },
    itemName: [
        fonts.medium,
        {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    ],
    itemDimension: {
        fontSize: fonts.small.fontSize,
        color: palette.neutralTertiary,
        marginBottom: 10,
        padding: '0px 16px'
    },
    chevron: {
        alignSelf: 'center',
        marginLeft: 10,
        color: palette.neutralTertiary,
        fontSize: fonts.large.fontSize,
        flexShrink: 0,
    },
});



export interface AllegatiProps {
    protocol?: IProtocol
    extraCssClass?: string
    onAttchmentClick: (item) => void
    onRemoveAttchmentClick: (ev, item) => void

}


const Allegati: React.FunctionComponent<AllegatiProps> = (props) => {

    const [fileList, setFileList] = useState<IFile[]>([]);
    const [loading, setLoading] = useState<boolean>(props.protocol && props.protocol.attachments ? false : true);

    const [isConfirmDialogOpen, { setTrue: showConfirmDialog, setFalse: dismissConfirmDialog }] = useBoolean(false);
    const [submitConfirmDialog, setSubmitConfirmDialog] = useState(() => () => { });

    useEffect(() => {
        let list = props.protocol && props.protocol.attachments ? props.protocol.attachments : [];
        setFileList([...list])
    }, [props.protocol]);

    const onRemoveFileItemClick = (ev, file: IFile | undefined) => {
        ev.stopPropagation();
        ev.preventDefault();

        let newAttachments = fileList?.filter(it => it != file);
        setFileList([...newAttachments])

        props.onRemoveAttchmentClick(ev, file);
    }

    const attachmentRenderIcon = (item) => {
        if (item.loading) {
            return <div style={{ fontSize: 20 }}> <FontAwesomeIcon icon={['fal', 'circle-notch']} spin /></div>;
        }
        else
            return <Icon {...getFileTypeIconProps({ extension: item.extension, size: 20 })} />;

    }

    const attachmentRenderCell = (item) => {

        const previewPropsUsingIcon: IDocumentCardPreviewProps = {
            previewImages: [
                {
                    previewIconProps: {
                        children: attachmentRenderIcon(item)
                    },
                    width: 63,

                }
            ],
            styles: {
                previewIcon: { backgroundColor: palette.neutralLighterAlt },
            },

        };

        let actions: IButtonProps[] = [];

        if (props.protocol && props.protocol.statoProtocollo !== Protocol_State.Annullato
            && (props.protocol.statoProtocollo !== Protocol_State.Protocollato
                || (props.protocol.statoProtocollo === Protocol_State.Protocollato && abilityBuild.can('use', subject('IFeature', { key: 'ModificaAllegatiPostProtocollazione', enabled: true }))))
            && abilityBuild.can('update', subject('IProtocol', props.protocol)))
            actions.push(
                {
                    iconProps: { iconName: 'Delete' },
                    onClick: (ev) => {
                        ev.stopPropagation();
                        ev.preventDefault();
                        setSubmitConfirmDialog(() => () => { deleteAttachmentSubmit(ev, item) })
                        showConfirmDialog()
                    },
                    ariaLabel: 'Elimina',
                }
            );

        let fileName = item.originalName ? item.originalName : item.fileName;
        return (
            <DocumentCard
                aria-label={fileName}
                type={DocumentCardType.compact}
                onClick={() => props.onAttchmentClick(item)}
                styles={documentCardSyles}
            >
                <DocumentCardPreview {...previewPropsUsingIcon} />
                <DocumentCardDetails>
                    <DocumentCardTitle title={fileName} className={classNames.itemName} />
                    <div className={classNames.itemDimension}>{AppUtilities.GetDimensionFileString(item)}</div>
                </DocumentCardDetails>
                <DocumentCardActions
                    actions={actions} />

            </DocumentCard>
        );
    };

    const deleteAttachmentSubmit = (ev, item) => {
        props.onRemoveAttchmentClick(ev, item);
        dismissConfirmDialog();

    }

    const abortConfirmDialog = () => {
        setSubmitConfirmDialog(() => () => { })
        dismissConfirmDialog();
    }

    const showFileList = () => {

        if (fileList.length > 0) {
            return <List items={fileList} onRenderCell={attachmentRenderCell} />
        }
        else
            return <Text nowrap block>
                Nessun allegato caricato
            </Text>
    }


    return (
        <div className={`allegati flex flex-column position-relative ${props.extraCssClass}`}>
            <CircleLoader loaderClass='loader-large' loading={loading} />
            <div className={'my-scroll-div'}>
                <div className={`my-component-content`}>

                    {showFileList()}

                </div>
            </div>

            <Dialog
                hidden={!isConfirmDialogOpen}
                onDismiss={abortConfirmDialog}
                dialogContentProps={{

                    type: DialogType.normal,
                    title: 'Conferma',
                    closeButtonAriaLabel: 'Close',
                    subText: `Vuoi eliminare l'allegato?`,
                }}
            >
                <DialogFooter>
                    <PrimaryButton onClick={submitConfirmDialog} text="Conferma" />
                    <DefaultButton onClick={abortConfirmDialog} text="Annulla" />
                </DialogFooter>

            </Dialog>
        </div>

    );
};

export default Allegati;

